module.exports = __webpack_public_path__ + "284ece7fe1e4e296bbc704d6dec864fe.fbx";